module.exports = __webpack_public_path__ + "static/img/turntable_new.eb28fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/turntable_new.png
// module id = 2zbr
// module chunks = 59